import { DirectiveOptions } from "vue";

// this will set the input inside the el-input-number ids so that the label can be linked to it
export const SetNumberInputIdDirective: DirectiveOptions = {
  inserted(el, binding) {
    setTimeout(() => {
      const inputElement = el.querySelector('input');
      if (inputElement) {
        inputElement.id = binding.value;
        inputElement.setAttribute('type', 'number');
      }
    }, 100); // Ensure input is fully rendered before modifying it
  },
};

export const SetNumberButtonsAccessibilityDirective: DirectiveOptions = {
  inserted(el, binding) {
    setTimeout(() => {
      const decreaseElement = el.querySelector('.el-input-number__decrease');
      if (decreaseElement) {
        decreaseElement.setAttribute('aria-label', `Decrease 1 ${binding.value}`);
      }

      const increaseElement = el.querySelector('.el-input-number__increase');
      if (increaseElement) {
        increaseElement.setAttribute('aria-label', `Increase 1 ${binding.value}`);
      }
    }, 100); // Ensure input is fully rendered before modifying it
  },
};